import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from '../../_service/message-service';
import { Subscription } from 'rxjs';
import { UserService } from 'src/app/_services';
import { UserInfoService } from 'src/app/_services/userInfo.service';
import { AuthenticationService } from 'src/app/_services';

declare var $: any;

@Component({
  selector: 'telio-edit-service-request',
  templateUrl: './edit-service-request.component.html',
  styleUrls: ['./edit-service-request.component.scss']
})
export class EditServiceRequestComponent implements OnInit, OnDestroy {

  constructor(private userservice: UserService,
    private formBuilder: UntypedFormBuilder,
    private toastr: SnackbarService,
    public translate: TranslateService,
    private route: Router,
    private authenticationService: AuthenticationService,
    private routed: ActivatedRoute, readonly userInfoService: UserInfoService) { }

  ticketId;
  ticketDetails;
  tikIssue;
  vendorEmail: any;
  vendorName: any;
  tikDes;
  tikUrl;
  mobile;
  commentsArray = [];
  superReply: boolean = false;
  requestUpdateForm: UntypedFormGroup;
  dateTime;
  Adminreply;
  input;
  subscription: Subscription = new Subscription;
  supportEmail = "";
  adminName: any;

  ngOnInit(): void {
    this.routed.queryParams.subscribe(params => {
      this.ticketId = params['ticketid']
    })
    this.getSupportEmail()
    this.requestUpdateForm = this.formBuilder.group({
      description: [null, Validators.required]
    })
    this.userservice.getTicketById(this.ticketId).subscribe((resp: any) => {
      this.ticketDetails = resp;
      this.tikIssue = this.ticketDetails.issuetype
      this.vendorEmail = this.ticketDetails.vendorEmail
      this.vendorName = this.ticketDetails.vendorName
      this.tikDes = this.ticketDetails.description
      this.tikUrl = this.ticketDetails.url
      this.mobile = this.ticketDetails.mobileNumber
      this.commentsArray = this.ticketDetails.comment
      this.dateTime = this.authenticationService.convert24HrTo12Hr(this.authenticationService.convertToLocalTime(this.ticketDetails.createdDate,this.userInfoService.userDetails.prefCountry))
      this.commentsArray.forEach((res: any, i: number) => {
        this.commentsArray[i]['superReply'] = this.superReply
        if (this.commentsArray[i].adminName == this.adminName) {
          this.commentsArray[i].superReply = true
        }
        this.commentsArray[i].timestamp = this.authenticationService.convert24HrTo12Hr(this.authenticationService.convertToLocalTime(this.commentsArray[i].timestamp,this.userInfoService.userDetails.prefCountry))
      })
    })
  }

  requestUpdate() {
    this.Adminreply = this.requestUpdateForm.value

    if (!this.requestUpdateForm.valid) {
      this.toastr.error(this.translate.instant('editServiceRequest.error'))
      return
    }

    this.input = {
      "emailId": this.supportEmail,
      "comment": this.Adminreply.description,
      "ticketId": this.ticketDetails.id,
      "adminName": this.adminName
    }
    this.userservice.UpdateTicket(this.input).subscribe(((resp: any) => {
      if (!!resp) {
        this.toastr.success(this.translate.instant('editServiceRequest.success'));
        this.topback();
      }
      else {
        this.toastr.error(resp)
      }
    }))
  }

  dateTransform(date: string) {
    let dateIn: Date = new Date(date);
    let dateOut = dateIn.toISOString().replace("T", " ").substring(0, 19);
    return dateOut;
  }

  viewScreenshot() {
    $("#viewAlert").modal('show');
  }

  getSupportEmail() {
    const tenantID = this.userInfoService.userDetails.tenantID || 'TELIOEV';
    this.subscription.add(this.userservice.getBrandInfoByTenantId(tenantID).subscribe((res: any) => {
      this.supportEmail = res.supportEmailId;
    },
      error => {
        this.supportEmail = "";
      }))
  }

  topback() {
    this.route.navigate(['/dashboard/service-request', { routeID: this.routed.snapshot.paramMap.get('routeID') }]);
  }

  ngOnDestroy() {
    this.subscription && this.subscription.unsubscribe();
  }
}
